import Vue from 'vue';
import selfCheckDefaults from '../../selfcheck/self-check-defaults';


const re_my_ans = /^my_ans_/;



export default function restore(state, LS_PREFIX) {
  let needSwitch = false;

  const newStates = {};
  const isSwitchTargetPrefix = LS_PREFIX === '2018_';
  const keys = $ls.index() || [];
  const re = new RegExp('^(default_)?' + LS_PREFIX);
  const subjects = {};

  const getSubject = id => {
    if (subjects[id]) return subjects[id];
    const subject = selfCheckDefaults();
    subjects[id] = subject;
    if (isSwitchTargetPrefix) needSwitch = true;
    return subject;
  }

  for (let realKey of keys) {
    if (!re.test(realKey)) continue;

    const key = realKey.replace(re, '');
    const value = $ls.get(realKey);

    if (re_my_ans.test(key)) {
      const subjectId = key.replace(re_my_ans, '');
      const subject = getSubject(subjectId);
      for (let key in value) {
        subject.inputs[key] = value[key].val;
      }
      continue;
    }

    if (key === 'selects') {
      for (let subjectId in value) {
        const data = value[subjectId];
        const subject = getSubject(subjectId);
        subject.selected = data.selected === undefined ? subject.selected : data.selected;
        subject.type = data.type || subject.type;
      }
      continue;
    }

    if (key === 'totals') {
      for (let subjectId in value) {
        const data = value[subjectId];
        const subject = getSubject(subjectId);
        subject.selfcheckScore = typeof data.score === 'number' ? data.score : subject.selfcheckScore;
        subject.directScore = typeof data.directScore === 'number' ? data.directScore : subject.directScore;
        subject.selfCheckIsFinished = data.status === undefined ? subject.selfCheckIsFinished : data.status;
      }
      continue;
    }

    if (value !== undefined) newStates[key] = JSON.parse(JSON.stringify(value));
  }

  const subjectIds = Object.keys(subjects);

  if (needSwitch) {
    const deleteKeys = [
      '2018_selects',
      '2018_totals',
      ...subjectIds.map(id => '2018_my_ans_' + id),
    ];

    for (let key of deleteKeys) {
      $ls.deleteKey(key);
    }
    for (let id of subjectIds) {
      $ls.set('2018_selfcheck-subject-' + id, subjects[id]);
    }
  }

  for (let id of subjectIds) {
    const value = subjects[id];
    if (value !== undefined) {
      newStates[`selfcheck-subject-${id}`] = JSON.parse(JSON.stringify(value));
    }
  }

  // lsに存在するキーはsetして、ないキーはdeleteする
  for (let key in state) {
    if (newStates[key] === undefined) Vue.delete(state, key);
  }
  for (let key in newStates) {
    Vue.set(state, key, newStates[key]);
  }
}



// WEBPACK FOOTER //
// ./src/js/store/modules/ls/util/restore.js